import { render, staticRenderFns } from "./dynamicDetail.vue?vue&type=template&id=60f32a8b&scoped=true&lang=html"
import script from "./dynamicDetail.vue?vue&type=script&lang=js"
export * from "./dynamicDetail.vue?vue&type=script&lang=js"
import style0 from "./dynamicDetail.vue?vue&type=style&index=0&id=60f32a8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f32a8b",
  null
  
)

export default component.exports